import {Injectable} from "@angular/core";

@Injectable()
export class ScrollTopService {
  public scrollTop(): void {
    window.scroll(0, 0);
  }
}
